import React from 'react'
import { useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import RequestSelectedUserData from 'redesign/components/atoms/Buttons/request-selected-users-data-button'
import HeaderWithBackButton from 'redesign/components/organisms/headers/header-with-back-button'
import Page from 'redesign/components/templates/Page'
import { STANDARD_PAGE_HORIZONTAL_PADDING } from 'shared/constants'
import type { ConfirmUserRequestDataPageProps } from './types'

const ConfirmRequestUserDataPage: React.FC<ConfirmUserRequestDataPageProps> = ({
  requestedUsersAmount,
  setShowConfirmForm,
}) => {
  const { t } = useFavurTranslation()
  const { palette } = useTheme()

  return (
    <Page
      backgroundColor={palette.background.base}
      paddingX={STANDARD_PAGE_HORIZONTAL_PADDING}
      removeLastMargin
      hideNativeNavigation
      header={
        <HeaderWithBackButton
          skipPushingBack
          onGoBack={() => setShowConfirmForm(false)}
          title={t('requestEmployeeData.common.overTitle')}
        />
      }
      footer={<RequestSelectedUserData isConfirming onClick={() => {}} requestedUsersAmount={requestedUsersAmount} />}
    >
      To be implemented
    </Page>
  )
}

export default ConfirmRequestUserDataPage
